// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2w4DN","productName":"Table_productName__gTNSc"};